module.exports = __webpack_public_path__ + "img/next.5b75c213.svg";